export const Heading_Section_Crm_Development_Services = {
    heading: "CRM Development Services"
  }
  
  export interface ICrmDevelopmentServicesStatItem {
    labelLines: string[];
    suffix: string;
    value: string;
  }
  
  export const Stats_Section_Crm_Development_Services: ICrmDevelopmentServicesStatItem[] = [
    {
      value: "+60",
      suffix: "%",
      labelLines: ["Time Saved in Daily OpS"],
    },
    {
      value: "3",
      suffix: "x",
      labelLines: ["Faster Lead-to-Sale Conversion"],
    },
    {
      value: "-40",
      suffix: "%",
      labelLines: ["Reduction in Manual Errors"],
    },
  ];
  